import "../CSS/Ploeg.css";

function U9B() {
  return (
    <div className="ploegoverzicht">
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_124025/overzicht"
      />
    </div>
  );
}

export default U9B;
